module.exports = __webpack_public_path__ + "img/组 2242@2x.e1b715ef.png";